const partImages: Array<[RegExp,string]> = [
  [/\bAPK 770\b/i,"handle-apk-770"],
  [/\bMBK (?:325-9|335-13)\b/i,"01"],
  [/\bMBK 603\b/i,"02"],
  [/\bMSL 408\b/i,"03"],
  [/\bMSL-K(?:9|13)\b/i,"04"],
  [/\bISP 202-/i,"05"],
  [/\bMBK 703\b/i,"06"],
  [/\bKKH 503-G\b/i,"07"],
  [/\bMKS 404-/i,"08"],
  [/\bARK 505-G/i,"09"],
  [/\bKNM 737-/i,"10"],
  [/\bKSM 720\b/i,"11"],
  [/\bHM 90-3\b/i,"12"],
  [/\bSM 606\b/i,"13"],
  [/\bKPT 900\b/i,"14"],
  [/\bIDK 213-G/i,"15"],
  [/\bGUK-(?:9|13)\b/i,"16"]
];

export function gevissPartImage(code:string):string|null {
  const part=partImages.find(([pattern])=>pattern.test(code))?.[1];
  return part?`/geviss/tilt-turn/part-${part}.png`:null;
}
